import { HttpStatusCode } from 'axios';
import useFetch from '@/composables/useFetch';
import { Note } from '@/model/note';

export async function getNoteList() {
	const res = await useFetch<Note[]>({
		url: '/note',
		method: 'GET',
		signalUUID: `GET_NOTE_LIST`
	});

	if (!res.data || res.error || res.status !== HttpStatusCode.Ok) {
		return [];
	}
	return res.data;
}

export async function getNote(noteUUID: string) {
	return await useFetch<Note>({
		url: '/note/' + noteUUID,
		method: 'GET'
	});
}

export async function saveNote(data: Note) {
	const res = await useFetch<{ noteUUID: string }>({
		url: '/note',
		method: 'PUT',
		data,
		signalUUID: `SAVE_NOTE`
	});
	return res.data?.noteUUID || '';
}

export async function deleteNote(noteUUID: string) {
	return await useFetch({
		url: '/note/' + noteUUID,
		method: 'DELETE'
	});
}

export async function favoriteNote(noteUUID: string, isFavorite: boolean) {
	return await useFetch({
		url: '/note/' + noteUUID,
		method: 'PATCH',
		data: { isFavorite }
	});
}

export async function reorderingNote(notes: { noteUUID: string; sequence: number }[]) {
	return await useFetch({
		url: `/note/reordering`,
		method: 'PATCH',
		data: { notes }
	});
}
